import Emitter from "./Emitter";

export default class ClosePaytable extends Emitter {
    constructor(gb) {
        super(gb);
    }

    LNWOGS_handler() {
        this.gb.wallet.closePaytable();
    }

    _default() {
        return
    }
}
